import styled from 'styled-components';
import {PrimaryButton, SecondaryButton} from '../Button';
import { devices } from '../../styles';

const PopupHomepage = props => {
    return (
        <PopupWrapper $isShowed={props.isShowed}>
            <PopupWrapperInner>
                <PopupBanner>
                    <PopupContent>
                        <PopupTitle>Return to Home</PopupTitle>
                        <PopupSubtitle>Starting over will lose any progress you've made so far!</PopupSubtitle>
                    </PopupContent>
                    <PopupButtons>
                        <SecondaryButton type="secondary" onClick={props.onHideBanner}>Cancel</SecondaryButton>
                        <PrimaryButton onClick={props.onStartOver}>Start over</PrimaryButton>
                    </PopupButtons>
                </PopupBanner>
            </PopupWrapperInner>
        </PopupWrapper>
    )
}

const PopupWrapper = styled.div`
    display: ${props => props.$isShowed ? 'block' : 'none'} !important;
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 0.75);
`;

const PopupWrapperInner = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media ${devices.tablet} {
        align-items: center;
    }
`;

const PopupBanner = styled.div`
    margin-inline: 24px;
    max-width: 481px;
    background-color: #fff;
    padding-top: 24px;
    border-radius: 24px;
    margin: auto;

    @media ${devices.tablet} {
        width: 481px;
    }
`;

const PopupContent = styled.div`
    margin-bottom: 16px;
    color: #000;
    text-align: center;
    padding: 0 16px 24px 16px;
    border-bottom: 1px solid #d4ccbd;
`;

const PopupTitle = styled.h2`
    margin-bottom: 24px;

    font-size:18px;
    line-height: 28px;
    
`;

const PopupSubtitle = styled.h4`
    margin: 30px 0 15px;
    font-weight: 400;
    font-size:16px;
    line-height: 26px;
`;

const PopupButtons = styled.div`
    display: flex;
    align-items: start;
    justify-content: space-between;
    padding: 0 16px 24px 16px;
`;

export default PopupHomepage;
